import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config || {};
    const isAuthRoute = ["/auth/login", "/auth/logout", "/auth/refresh"].some((p) => (original.url || "").includes(p));
    if (err.response?.status === 401 && !original._retry && !isAuthRoute) {
      original._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(original);
      } catch {
        if (!window.location.pathname.startsWith("/welcome")) window.location.href = "/welcome";
      }
    }
    return Promise.reject(err);
  }
);

export const apiError = (e, fallback = "Something went wrong") => {
  const detail = e.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).join(" ");
  return fallback;
};

export default api;
